import { render, staticRenderFns } from "./PresentationCard.vue?vue&type=template&id=85569b3e&scoped=true&"
import script from "./PresentationCard.vue?vue&type=script&lang=ts&"
export * from "./PresentationCard.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationCard.vue?vue&type=style&index=0&id=85569b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85569b3e",
  null
  
)

export default component.exports